module.exports = __webpack_public_path__ + "media/images/games/rocket-league/hiw-1-14bbe7283c883b35247b32d7df756d4d.jpg";